// Tipos de compras (INDUSTRIA.md, onda 3). O que diferencia esta tela de um
// "ponto de pedido" comum é a necessidade líquida: demanda das OPs menos saldo
// do dono menos o que já está pedido, com o lead time do fornecedor virando data.
import type { MaterialUnit } from './industria'

export type PurchaseStatus = 'draft' | 'ordered' | 'partial' | 'received' | 'cancelled'
export type PayableStatus = 'open' | 'paid' | 'cancelled'

export const PURCHASE_STATUS_LABEL: Record<PurchaseStatus, string> = {
  draft: 'Rascunho',
  ordered: 'Enviado',
  partial: 'Recebido em parte',
  received: 'Recebido',
  cancelled: 'Cancelado',
}

export const PURCHASE_STATUS_BADGE: Record<PurchaseStatus, 'default' | 'success' | 'warning' | 'danger' | 'info'> = {
  draft: 'default', ordered: 'info', partial: 'warning', received: 'success', cancelled: 'default',
}

export const PAYABLE_STATUS_LABEL: Record<PayableStatus, string> = {
  open: 'Em aberto', paid: 'Pago', cancelled: 'Cancelado',
}

export type NeedRow = {
  materialId: string; materialCode: string; materialName: string; unit: MaterialUnit
  ownerTenantId: string | null; ownerName: string | null
  demand: number; balance: number; onOrder: number; need: number
  minQty: number; reorderQty: number | null; avgCost: string | null
  supplierId: string | null; supplierName: string | null; leadTimeDays: number | null
  neededAt: string | null; buyBy: string | null; late: boolean
  orders: string[]
}

export type PurchaseRow = {
  id: string; number: string
  supplierId: string; supplierName: string | null; leadTimeDays: number | null
  tenantId: string | null; tenantName: string | null
  entryMode: string; status: PurchaseStatus
  issuedAt: string | null; expectedAt: string | null
  docNumber: string | null; totalValue: string | null
  createdAt: string; itemCount: number; pendingQty: number
}

export type PurchaseItem = {
  id: string; materialId: string; materialCode: string; materialName: string
  unit: MaterialUnit; lotControlled: boolean
  qtyOrdered: number; qtyReceived: number; unitCost: string | null; notes: string | null
}

export type PurchaseDetail = Omit<PurchaseRow, 'itemCount' | 'pendingQty'> & {
  docKey: string | null; notes: string | null; author: string | null
  items: PurchaseItem[]
  lots: {
    id: string; lotNumber: string; materialCode: string; materialName: string
    qtyReceived: number; unitCost: string | null; expiryDate: string | null; receivedAt: string
  }[]
  payables: {
    id: string; description: string; amount: string
    dueDate: string | null; status: PayableStatus; paidAt: string | null
  }[]
}

export type PayableRow = {
  id: string; purchaseId: string | null; purchaseNumber: string | null
  supplierId: string; supplierName: string | null
  tenantId: string | null; tenantName: string | null
  description: string; amount: string; dueDate: string | null
  status: PayableStatus; paidAt: string | null; paidAmount: string | null
  notes: string | null; createdAt: string
}

export type SupplierSummary = {
  id: string; name: string; cnpj: string | null; email: string | null
  phone: string | null; leadTimeDays: number | null; active: boolean
  openPurchases: number; openAmount: number; materialCount: number
}

/** Vencido, ou vence nos próximos `days` dias. */
export function dueSoon(due: string | null, days = 7): boolean {
  if (!due) return false
  const limit = new Date()
  limit.setDate(limit.getDate() + days)
  return due <= limit.toISOString().slice(0, 10)
}
